import { render, staticRenderFns } from "./TipoContrato.vue?vue&type=template&id=5cef7803&"
import script from "./TipoContrato.vue?vue&type=script&lang=js&"
export * from "./TipoContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports